<template>
  <b-container fluid>
    <b-breadcrumb :items="breadcrumbs"/>
    <b-row>
      <b-col class="mb-3" md="6">
        <b-card title="Print QR Codes">
          <b-form v-on:submit.prevent.stop="submit">
            <b-form-group id="shipping_team_label" label="Shipping Team" label-for="shipping_team">
              <b-form-select id="shipping_team" :options="teams" required v-model="printOptions.team">
                <template slot="first">
                  <option :value="null" disabled>Select a team</option>
                </template>
              </b-form-select>
            </b-form-group>
            <b-form-group id="workflow_label" label="Workflow" label-for="workflow">
              <b-form-select id="workflow" :options="workflows" required v-model="printOptions.workflow">
                <template slot="first">
                  <option :value="null" disabled>Select a workflow</option>
                </template>
              </b-form-select>
            </b-form-group>
            <b-form-group label="Auto Generate Job Numbers?">
              <b-form-radio-group id="job_numbers" v-model="printOptions.autoGenerateJobNumbers" stacked name="job_numbers">
                <b-form-radio :value="true">
                  Yes, automatically generate random job numbers
                  <b-badge variant="warning">* for demonstration and testing purposes only</b-badge>
                </b-form-radio>
                <b-form-radio :value="false">No, users will enter job numbers during scan</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <b-form-group id="layout_label" label="Label Sheet Type" label-for="layout">
              <b-form-select id="layout" :options="layouts" required v-model="printOptions.layout">
                <template slot="first">
                  <option :value="null" disabled>Select a sheet type</option>
                </template>
              </b-form-select>
            </b-form-group>
            <div class="text-right">
              <b-button to="/" exact>Cancel</b-button>
              <b-button type="submit" variant="primary">Generate PDF</b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import API from '@/lib/api'

export default {
  name: 'PrintCodes',
  data () {
    return {
      breadcrumbs: [{text: 'My Vos Voco', to: '/'}, {text: 'Print QR Codes', to: '/print', active: true}],
      printOptions: {
        team: null,
        workflow: null,
        autoGenerateJobNumbers: false,
        layout: null
      },
      layouts: [],
      workflows: this.$store.getters.workflows
        .map((workflow) => { return {text: workflow.name, value: workflow} }),
      teams: this.$store.state.user.team_users
        .filter((teamUser) => teamUser.permissions.indexOf('print_qr_codes') !== -1)
        .map((teamUser) => { return {text: teamUser.team.name, value: teamUser.team} })
    }
  },
  created () {
    this.fetchOptions()
  },
  methods: {
    fetchOptions () {
      API.get('labels/layouts', {}, this.$store.getters.authHeaders)
        .then((response) => {
          this.layouts = response.data.layouts.map((layout) => { return {text: layout.name, value: layout} })
        })
    },
    submit () {
      const params = {
        team_id: this.printOptions.team.id,
        workflow_id: this.printOptions.workflow.id,
        auto_generate_job_numbers: this.printOptions.autoGenerateJobNumbers,
        layout_id: this.printOptions.layout.id
      }
      API.post('/trackers', params, this.$store.getters.authHeaders)
        .then((response) => {
          const url = response.data.print_url
          setTimeout(() => {
            document.location = url
          }, 150)
        })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/PrintCodes.vue